import React from "react";

function highlight(text, query) {
  if (!query) return text;
  try {
    const parts = text.split(new RegExp(`(${query.replace(/[.*+?^${}()|[\\]\\\\]/g,"\\$&")})`, "ig"));
    return parts.map((p,i)=>
      p.toLowerCase() === query.toLowerCase()
        ? <mark key={i}>{p}</mark>
        : <React.Fragment key={i}>{p}</React.Fragment>
    );
  } catch {
    return text;
  }
}

// results: [{ url, title, snippet }]
function Results({ results, loading, error, defaultImage, hasQuery, hasFetched, query, onResultClick }) {
  if (!hasQuery) return null;
  if (loading) return null; // spinner handled by overlay
  const showNoResults = hasFetched && !loading && !error && results.length === 0;
  if (showNoResults) return null;

  const handleResultClick = (url) => {
    if (onResultClick) {
      onResultClick();
    }
    // The link will still navigate due to target="_parent"
  };

  return (
    <div className="results no-nested-scroll">
      {!loading && !error && results.map((item,i)=>{
        const hasLink = !!item.url;
        return (
          <div key={i} className="card">
            <div className="card-inner">
              {hasLink ? (
                <a
                  href={item.url}
                  target="_parent"
                  className="result-thumb-link"
                  aria-label={item.title || "Open result"}
                  onClick={() => handleResultClick(item.url)}
                >
                  <img src={defaultImage} alt={item.title || "Result"} className="result-thumb"/>
                </a>
              ) : (
                <img src={defaultImage} alt={item.title || "Result"} className="result-thumb"/>
              )}
              <div className="card-text">
                <h4 className="result-title">
                  {hasLink ? (
                    <a 
                      href={item.url} 
                      target="_parent" 
                      className="result-title-link"
                      onClick={() => handleResultClick(item.url)}
                    >
                      {highlight(item.title || "", query)}
                    </a>
                  ) : highlight(item.title || "", query)}
                </h4>
                <p className="result-snippet">{highlight(item.snippet || "", query)}</p>
                {item.url && (
                  <p className="result-link">
                    <a 
                      href={item.url} 
                      target="_parent"
                      onClick={() => handleResultClick(item.url)}
                    >
                      {item.url}
                    </a>
                  </p>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Results;
